import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { Notice } from '../../models/notice';
import { NoticesService } from '../../services/notices.service';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { NoticeAttachment } from '../../models/notice-attachment';
import { AppSettings } from '../../../../../utils/app-settings';
import { FileDownloadService } from '../../../../../services/file-download-service/file-download.service';
import { Device } from '@ionic-native/device/ngx';

@Component({
  selector: 'app-notice-details',
  templateUrl: './notice-details.component.html',
  styleUrls: ['./notice-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NoticeDetailsComponent extends ComponentBase implements OnInit {

  @Input() noticeId: number;
  selectedNotice: Notice;
  subscription: Subscription = new Subscription();
  loading: boolean = false;

  constructor(private noticesService: NoticesService
    , private fileDownloadService: FileDownloadService
    , public device: Device) {
    super();
  }

  ngOnInit() {
    this.addSubscription(this.subscription);
  }

  ngOnChanges() {
    if (!this.noticeId) {
      this.loading = true;
    }

    if (this.noticeId) {
      this.loading = true;
      this.subscription = this.noticesService.getNoticeById(this.noticeId)
        .subscribe((res) => {
          this.selectedNotice = res;
          this.loading = false;
        });
    }
  }

  isImage(contentType: string) {
    return contentType.includes("image");
  }

  downloadAndOpenAttachment(notice_id: number, attachment: NoticeAttachment) {
    let url = AppSettings.apiUrl + "Notices/" + notice_id + "/Attachments/" + attachment.announcement_document_id;
    this.fileDownloadService.downloadAndOpen(url, attachment.file_name, attachment.content_type).subscribe();
  }
}
